import { useLocation } from '../context/LocationContext';
import { useMemo } from 'react';
import { usePlacements } from '../context/PlacementsStore';

// Read synchronously rather than via useQuery. A synchronous queryFn resolves with no async
// boundary, so on react-query 5.101 (which notifies on every setOptions) the observer
// resolved+notified within the same render cycle, driving a self-sustaining re-render loop. The
// loop only surfaced in the printer-app webview, where `ios_placement_id` is set. (issue #1027)
const readIosPlacementId = (): number | null => {
  const id = localStorage.getItem('ios_placement_id');
  return id ? Number(id) : null;
};

export const useDefaultPlacement = () => {
  const iosPlacementId = readIosPlacementId();
  const placements = usePlacements();

  return useMemo(() => {
    if (iosPlacementId) {
      return { defaultPlacement: iosPlacementId };
    }

    if (placements[0] && placements.length === 1) {
      return { defaultPlacement: placements[0].id };
    }

    return { defaultPlacement: undefined };
  }, [iosPlacementId, placements]);
};

export const useAutomaticPrintingPlacement = () => {
  const { defaultPlacement } = useDefaultPlacement();
  const { location } = useLocation();

  /**
   * UK have been using cash for a while already and we do not want to automatically print cash receipts in UK just because its a legal requirement in Norway
   */
  if (location?.countryCode === 'UK') {
    return { defaultPlacement: undefined };
  }

  return { defaultPlacement };
};
